module.exports = __webpack_public_path__ + "img/1.484b1a6d.jpg";